import styled from 'styled-components'

import { MAX_SEARCH_FORM_WIDTH, SEARCH_BAR_SECOND_LINE_BREAK } from '@/constants/others'
import { zIndexRegistry } from '@/constants/zIndexRegistry'
import { TextLink } from '@/ui/atoms/text-link'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const SearchBarContainer = styled.div<{ showSearchBar?: boolean }>(
  ({ showSearchBar }) => `
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  order: 3;
  width: 100%;
  z-index: ${zIndexRegistry.DROPDOWN};
  
  /** Prevent Layout Shift */
  min-height: ${showSearchBar ? '10.7rem' : 'unset'};
  max-width: 100%;
  
  ${SEARCH_BAR_SECOND_LINE_BREAK} {
    align-items: center;
    flex-direction: row;
    flex: 1 0 auto;
    order: 2;
    
    /** Prevent Layout Shift */
    min-height: ${showSearchBar ? '5.1rem' : 'unset'};
    max-width: ${showSearchBar ? '80.2rem' : 'unset'};
  }
`
)

export const SearchFieldContainer = styled.form(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.default};
  margin: ${theme.spacing.default} 0;
  max-height: 11.7rem;
  overflow: visible;
  width: 100%;
  
  ${MEDIA_QUERIES(theme).medium} {
    border-radius: ${theme.spacing.mini};
    border: 0.1rem solid ${theme.colors.grey.light3};
    flex-direction: row;
    gap: 0;
    height: 5.1rem;
  }
  
  ${SEARCH_BAR_SECOND_LINE_BREAK} {
    max-width: ${MAX_SEARCH_FORM_WIDTH};
    margin: 0;
  }
  `
)

export const SearchFieldWrapper = styled.div(
  ({ theme }) => `
  width: 100%;
  z-index: ${zIndexRegistry.DROPDOWN};
  height: 5.1rem;

  ${MEDIA_QUERIES(theme).medium} {
    // TODO: revisit dropdown component in the UI library to remove nested div selection
    & > div {
      margin-top: -.1rem;
    }

    & > div > div > div > div {
      border: none;
    }
  }
`
)

export const Divider = styled.div(
  ({ theme }) => `
  display: none;

  ${MEDIA_QUERIES(theme).medium} {
    background-color: ${theme.colors.grey.light3};
    display: block;
    flex-shrink: 0;
    margin: ${theme.spacing.defaultSmall} 0;
    width: 0.1rem;
  }
`
)

export const ButtonWrapper = styled.div(
  ({ theme }) => `
  display: none;

  ${MEDIA_QUERIES(theme).medium} {
    margin-top: -0.1rem;
    margin-right: -0.1rem;
    display: flex;

    & > button {
      height: calc(100% + .1rem);
      min-width: 13rem
    }
  }
`
)

export const LocationContainer = styled.div(
  ({ theme }) => `
  display: flex;
  flex-shrink: 0;
  margin: 0;

  > svg {
    color: ${theme.colors.purple.primary};
    height: ${theme.spacing.large};
    width: ${theme.spacing.large};
  }

  ${MEDIA_QUERIES(theme).large} {
    margin-left: ${theme.spacing.default};
  }
`
)

export const LocationButton = styled(TextLink)(
  ({ theme }) => `
  align-items: center;
  display: flex;
  flex-shrink: 0;

  ${MEDIA_QUERIES(theme).medium} {
    margin-left: ${theme.spacing.default};
  }
`
)

export const LocationIconContainer = styled.div(
  ({ theme }) => `
  height: 2.4rem;
  width: 2.4rem;

  & > svg {
    color: ${theme.colors.purple.primary};
    height: 2.4rem;
    width: 2.4rem;
  }
`
)

export const LocationName = styled.span(
  ({ theme }) => `
  flex-shrink: 0;
  margin-left: ${theme.spacing.defaultSmall};
  max-width: 11rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
)

export const LocationRadius = styled.span`
  white-space: nowrap;
`

type MobileSearchBarProps = {
  isMobileHeaderExpanded: boolean
}

export const MobileButtonContainer = styled.div<MobileSearchBarProps>(
  ({ theme, isMobileHeaderExpanded }) => `
  border-top: 0.1rem solid ${theme.colors.grey.light3};
  margin: ${theme.spacing.default} -${theme.spacing.default} -${theme.spacing.default} -${
    theme.spacing.default
  };
  padding: ${theme.spacing.default};
  display: ${isMobileHeaderExpanded ? 'block' : 'none'};

  ${MEDIA_QUERIES(theme).medium} {
    display: none;
  }
  `
)
